"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.discordNotify = exports.createLevelTitle = exports.batchMention = exports.mentionUser = exports.messageConverter = exports.isDebug = exports.getMode = exports.setDebug = exports.setMode = exports.setProductionMode = exports.enableProduction = exports.DISCORD_ROLE_CS = exports.DISCORD_ROLE_UX = exports.DISCORD_ROLE_SALES = exports.DISCORD_ROLE_PRODUCT = exports.DISCORD_ROLE_MARKETING = exports.DISCORD_ROLE_TEAM = exports.DISCORD_ROLE_DEV = exports.DISCORD_ROLE_ADMIN = exports.DISCORD_ROLE_RIP = exports.DISCORD_ID_LEANDRO = exports.DISCORD_ID_MARCEL = exports.DISCORD_ID_NEUBER = exports.LINE_DIVIDER = exports.ALERT_LEVEL_ERROR = exports.ALERT_LEVEL_WARNING = exports.ALERT_LEVEL_SUCCESS = exports.BOT_ENDPOINT_RENEW = exports.BOT_ENDPOINT_FIRE_INSURANCE = exports.BOT_ENDPOINT_READJUSTMENTS = exports.BOT_ENDPOINT_PAYMENTS = exports.BOT_ENDPOINT_OTHERS = exports.BOT_ENDPOINT_ALERTS = exports.BOT_ENDPOINT_GIUDICINER = exports.BOT_ENDPOINT_DOMINER = exports.BOT_ENDPOINT_CALINER = exports.BOT_ENDPOINT_PLAYGROUND = void 0;
const cross_fetch_1 = require("cross-fetch");
exports.BOT_ENDPOINT_PLAYGROUND = 'https://discord.com/api/webhooks/783501021703045131/fH7B5E63-Amdd1WvvU8r8XmOacJPE2R16wxf5ymOCr8LEG2OimNExK1cpZTczE14oLXI';
exports.BOT_ENDPOINT_CALINER = 'https://discord.com/api/webhooks/781360755643121724/ItNT0Umd5TRvHzOjH8e7cjYq4PKC6C-ZJTzvgH4Akzz6uVOUStUVpvn7rStUmzxjaWlb';
exports.BOT_ENDPOINT_DOMINER = 'https://discord.com/api/webhooks/882751303120461875/LgwhONE6iunSaWeSzCXQYFUwttUyKeD3YDYYf8frK854bEh2vFL-QqhGdELTTVSSm8uB';
exports.BOT_ENDPOINT_GIUDICINER = 'https://discord.com/api/webhooks/953420463885926432/AkkO0kvU5iN8cALMzbB0iqjWdmzG186LByJNcopXJMNKG_KIV3VZHKr0BbysyHAUq1ML';
exports.BOT_ENDPOINT_ALERTS = 'https://discord.com/api/webhooks/996130110111494144/HCIKcslWVXW-gmz44ltgOBShX1eb1j1o9_RdBVcYObqF54mGI2HKfkIZ-UNwaEhkY-zU';
exports.BOT_ENDPOINT_OTHERS = 'https://discord.com/api/webhooks/996132895074828340/2MlaXCpiTCw1jJ3kRV9bv0XZ01vWdhtEOucMqhnygyCDvHuAnQLZF81Y319pQ_Jdpzo9';
exports.BOT_ENDPOINT_PAYMENTS = 'https://discord.com/api/webhooks/996115417342943312/HBB1rPlQCVsycujwoytMulKGWTDOXvguKgAU9Xliu2bofDSH011vSdnssqLR3FMeU9R5';
exports.BOT_ENDPOINT_READJUSTMENTS = 'https://discord.com/api/webhooks/996130269155299348/01KpRiuh6eOVwWoiK6QGA8IGkaH2QkyTlORUp5RK-XvSmnhhCqlHXNxlJYtL9NFbICv2';
exports.BOT_ENDPOINT_FIRE_INSURANCE = 'https://discord.com/api/webhooks/996140256481001602/L3HRFYqo_qmruCBYsFpRffFbS53iOPRrylptySCb4YZqSAaoxBygmZqp6xzeeHf2gKEG';
exports.BOT_ENDPOINT_RENEW = 'https://discord.com/api/webhooks/1007345457959276624/T5Xuf4kMoTwYdgQEcxik2xp9UtmKkxH8XtydXm1JXnphXpm3eY1wOHI4kKPaxLfarMAE';
exports.ALERT_LEVEL_SUCCESS = 'success';
exports.ALERT_LEVEL_WARNING = 'warning';
exports.ALERT_LEVEL_ERROR = 'error';
let mode = 'playground';
let debug = true;
exports.LINE_DIVIDER = '------------------------------------------------------------------------------';
exports.DISCORD_ID_NEUBER = '616652086930571277';
exports.DISCORD_ID_MARCEL = '742843703848075295';
exports.DISCORD_ID_LEANDRO = '755061354204758037';
// para enviar para um cargo(role) deve ser no formato <@&ID_ROLE>  por isso os IDs aqui estao com o & no inicio
exports.DISCORD_ROLE_RIP = '&849641930198745139';
exports.DISCORD_ROLE_ADMIN = '&742858462085644401';
exports.DISCORD_ROLE_DEV = '&742423488543064095';
exports.DISCORD_ROLE_TEAM = '&755055317288616007';
exports.DISCORD_ROLE_MARKETING = '&859464486796656661';
exports.DISCORD_ROLE_PRODUCT = '&900427445805666377';
exports.DISCORD_ROLE_SALES = '&754005986695708819';
exports.DISCORD_ROLE_UX = '&755054244490641489';
exports.DISCORD_ROLE_CS = '&1139876065448308836';
const getUrl = (alternativeUrl) => {
    let url = exports.BOT_ENDPOINT_CALINER; // URL padrao
    if (isPlayground()) {
        url = exports.BOT_ENDPOINT_PLAYGROUND;
    }
    else if (isProduction() && alternativeUrl) {
        url = alternativeUrl;
    }
    return url;
};
const mapLevelToEmoji = {
    [exports.ALERT_LEVEL_SUCCESS]: ':green_circle:',
    [exports.ALERT_LEVEL_WARNING]: ':yellow_circle:',
    [exports.ALERT_LEVEL_ERROR]: ':red_circle:',
};
exports.enableProduction = () => (mode = 'production');
exports.setProductionMode = exports.enableProduction;
exports.setMode = (m) => (mode = m);
exports.setDebug = (enable) => (debug = enable);
exports.getMode = () => mode;
exports.isDebug = () => debug;
const isProduction = () => mode === 'production';
const isPlayground = () => mode === 'playground';
const isConsole = () => mode === 'console';
const logMessage = (content, success, err) => {
    if (!debug) {
        return undefined;
    }
    console.log('---------------- START DISCORD DEBUG MESSAGE ----------------');
    console.log('Mode: ', mode);
    console.log('Delivery status: ', success ? 'OK' : 'Falha');
    console.log(content);
    if (err) {
        console.log(err);
    }
    console.log('---------------- END DISCORD DEBUG MESSAGE ----------------');
};
const getAlertMoji = (alertLevel) => {
    let emoji = '';
    if (mapLevelToEmoji[alertLevel]) {
        emoji = mapLevelToEmoji[alertLevel];
    }
    return emoji;
};
// const applyDivider = process.env.NODE_ENV === 'test'
exports.messageConverter = (message, applyDivider = false) => {
    let finalMsg = '';
    let lines = [];
    if (typeof message === 'string') {
        lines = [message];
    }
    else if (Array.isArray(message)) {
        lines = message;
    }
    if (applyDivider) {
        lines.push(exports.LINE_DIVIDER);
    }
    finalMsg = lines.join('\n');
    return finalMsg;
};
exports.mentionUser = (id) => (id ? `<@${id}>` : '');
exports.batchMention = (ids) => ids.map((id) => exports.mentionUser(id)).join(' ');
exports.createLevelTitle = (alertLevel, title = '') => {
    return [getAlertMoji(alertLevel), title].filter((txt) => txt).join(' ');
};
/**
 * @param {MessagePayload} message
 * @param {string} url
 * @returns {Promise<number>} status code for request, 201 means success
 */
exports.discordNotify = async (message, url, applyDivider = true) => {
    const messageContent = exports.messageConverter(message, applyDivider);
    const requestPayload = {
        content: messageContent,
        allowed_mentions: {
            parse: ['users', 'roles'],
        },
    };
    if (isConsole()) {
        logMessage(messageContent, true);
        return Promise.resolve(messageContent);
    }
    const requestOptions = {
        headers: {
            'Content-Type': 'application/json',
        },
        method: 'POST',
        body: JSON.stringify(requestPayload),
    };
    const endpoint = getUrl(url);
    return new Promise((resolve, reject) => {
        cross_fetch_1.default(endpoint, requestOptions)
            .then((resp) => {
            logMessage(messageContent, true);
            resolve(messageContent);
        })
            .catch((err) => {
            logMessage(messageContent, false, err);
            resolve(messageContent);
        });
    });
};
//# sourceMappingURL=index.js.map